import Chart from "react-apexcharts";

export default function HeatmapChart({ categories, series, height = 380, colorRange }) {
  const options = {
    chart: { type: "heatmap", toolbar: { show: false }, fontFamily: "Inter, sans-serif" },
    dataLabels: {
      enabled: true,
      style: { fontSize: "10px", fontWeight: 600 },
      formatter: (v) => (v > 0 ? `${v}%` : ""),
    },
    colors: ["#7C3AED"],
    xaxis: {
      categories,
      labels: { style: { fontSize: "11px", colors: "#64748B" } },
    },
    yaxis: {
      labels: { style: { fontSize: "11px", colors: "#334155" } },
    },
    plotOptions: {
      heatmap: {
        radius: 4,
        useFillColorAsStroke: false,
        colorScale: colorRange || {
          ranges: [
            { from: 0, to: 0, color: "#F1F5F9", name: "N/A" },
            { from: 1, to: 25, color: "#FCA5A5", name: "Bajo" },
            { from: 26, to: 50, color: "#FCD34D", name: "Medio" },
            { from: 51, to: 80, color: "#86EFAC", name: "Alto" },
            { from: 81, to: 100, color: "#34D399", name: "Excelente" },
          ],
        },
      },
    },
    grid: { padding: { right: 20 } },
    tooltip: {
      y: { formatter: (v) => `${v}%` },
    },
  };

  return <Chart options={options} series={series} type="heatmap" height={height} />;
}
